import { Building2, Cake, MessageSquareText, Stethoscope, HardHat, PartyPopper, Brain, Boxes, Wand2, Bot, Rocket, Target } from "lucide-react";

export const BESPOKE_DOMAINS = [
  { icon: HardHat, name: "Construction", note: "Flagship: Nirmana (Prem Constructions, 22-floor Bangalore)" },
  { icon: Stethoscope, name: "Clinics", note: "Appointments, patient follow-up, front-desk automation" },
  { icon: PartyPopper, name: "Event Management", note: "Enquiries, pipeline, staff, vendor coordination" },
  { icon: Building2, name: "Co-working & Service", note: "AMC, tickets, hub operations" },
];

export const ACADEMY_COURSES = [
  { icon: Wand2, name: "Prompt Engineering", note: "Get real work out of ChatGPT/Claude/Gemini." },
  { icon: Boxes, name: "RAG & MCP", note: "Bring your business data to LLMs — safely." },
  { icon: Brain, name: "Local LLMs", note: "Run models on your own hardware for privacy." },
  { icon: Bot, name: "AI Agents & Voice", note: "Automations, agents and voice AI that actually work." },
  { icon: Rocket, name: "Vibe Coding with AI", note: "Ship real software using AI as your co-builder." },
  { icon: Target, name: "Solve & Ship", note: "Turn a business problem into a working AI solution." },
];
